export default __webpack_public_path__ + "static/media/slider1.00a3627e.png";